module.exports = __webpack_public_path__ + "static/media/location--white.49c45ece.svg";